import { forwardRef } from 'react'
import { TextInputField, TextInputFieldProps } from 'utoniq-ui'

import { useMessage, useTranslation } from '@/core'
import { CellFrame, Organism } from '@/core/architecture'
import { Form, useForm, UseFormProps } from '@/core/form'

export type RetweetFormProps = {
  onSubmitTweet: (values: RetweetFormValues) => Promise<void>
}

export type RetweetFormValues = {
  tweet: string
}

const schema: UseFormProps['schema'] = o => ({
  tweet: o.string(),
})

const defaultValues = {
  tweet: '',
}

export const RetweetForm: Organism<RetweetFormProps> = ({ onSubmitTweet }) => {
  const { t } = useTranslation('missionDetail')
  const { showMessage, showError } = useMessage()
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<RetweetFormValues>({
    schema,
    defaultValues,
  })

  const onSubmit = handleSubmit(values => {
    return onSubmitTweet(values)
      .then(() => showMessage(t('success')))
      .catch((e: Error) => showError(e))
  })

  return (
    <Form id="retweet-form" onSubmit={onSubmit} sx={{ bgcolor: 'transparent' }}>
      <TextInputCell
        type="text"
        error={errors?.tweet}
        {...register('tweet')}
        textFieldProps={{
          sx: { px: 5, bgcolor: 'transparent', mb: 0, pb: 0 },
          multiline: true,
          minRows: 2,
          variant: 'standard',
          helperText: '',
          InputProps: {
            sx: { border: 'none' },
            disableUnderline: true,
          },
        }}
      />
    </Form>
  )
}

const TextInputCell = forwardRef(
  (props: Omit<TextInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('missionDetail')
    return (
      <CellFrame>
        <TextInputField {...props} ref={ref} t={t} />
      </CellFrame>
    )
  }
)
